import { calculateAgeMonths, normalizeSpeciesSlug } from './core';

const PREGNANCY_HINTS = new Set([
  'pregnant',
  'confirmed',
  'bred',
  'pending_pregnancy_check',
  'pregnant_with_two_kids',
  'pregnant_with_2_plus_kids',
  'doubtful',
]);

/**
 * Normalize an animal (or form-shaped object) for lifecycle label resolution.
 *
 * @param {object|null|undefined} animal
 */
export function animalToLifecycleParams(animal) {
  if (!animal) {
    return {
      speciesSlug: '',
      gender: null,
      ageMonths: null,
      breedingStatus: null,
      isPregnant: false,
    };
  }

  const category = animal.category ?? animal.category_name ?? animal.categoryName;
  const speciesSlug = normalizeSpeciesSlug(category?.slug ?? category?.name ?? category);

  const ageMonths = calculateAgeMonths({
    dateOfBirth: animal.date_of_birth ?? animal.dateOfBirth,
    fallbackAgeMonths: animal.age_months ?? animal.ageMonths,
  });

  const breedingStatus =
    animal.breeding_status
    ?? animal.breedingStatus
    ?? null;

  const pregnancyRaw = (breedingStatus || animal.pregnancy_status || '').toString().toLowerCase();
  const isPregnant = PREGNANCY_HINTS.has(pregnancyRaw)
    || String(animal.status || '').toLowerCase() === 'pregnant';

  return {
    speciesSlug,
    gender: animal.gender ?? null,
    ageMonths,
    breedingStatus,
    isPregnant,
  };
}
